import Centrifuge from 'centrifuge'
import Sound from '@/classes/Sound'

const centrifuge = new Centrifuge(process.env.VUE_APP_CENTRIFUGE_URL)

export const centrifugeConnect = (context) => {
  centrifuge.setToken(localStorage.currentUserToken)
  centrifuge.connect()
  centrifuge.on('connect', function (ctx) {
    // получаем список диалогов для виджета чата (true обозначает необходимость подписаться на каналы)
    context.dispatch('getDialogRoomList', { needSubscribe: true, updateCurrent: false }).then(() => {
      context.commit('UPDATE_DIALOG_WIDGET_COUNTER')
    })
    // подписываемся на канал системных сообщений
    centrifugeSubscribe('channel_system', context)
    centrifugeSubscribe('user_' + localStorage.getItem('currentUserId'), context)
  })
  centrifuge.on('disconnect', function (ctx) {
  })
}

// в value триггер для вызова определенных действий при прослушивании
// в data всякая необходимая доп инфа, room_id и т.д.
export const centrifugePublish = (channel, value, publishData) => {
  centrifuge.publish(channel, { value, publish_data: publishData }).then(response => {
  }).catch(error => {
    console.log(`${value} publish error`, error)
  })
}

export const centrifugeSubscribe = (channel, context) => {
  centrifuge.subscribe(channel, function (ctx) {
    const data = ctx.data
    const currentUserId = context ? context.rootState.appData.currentUser.id : null
    const currentDialogRoom = context && context.state.currentDialog ? context.state.currentDialog : null

    // Уведомление при новом сообщении
    if (data?.publish_data?.is_new) {
      Sound.notification.play()
    }

    // вызываем экшоны и запросы на апи вязанные с чатом, только в том случае, если выбран диалог на который прилетел триггер
    if (currentDialogRoom && currentDialogRoom.id === data.publish_data.room_id) {
      switch (data.value) {
        case 'update-messages':
          // триггер может приходить с разной датой
          // room_id приходит всегда
          // is_new - для новых сообщений
          // is_updated - id сообщения, которое отредактировано
          // user_id - для определения, что инициировал текущий юзер и нужно подскролить к низу окна чата
          // removed_id - для удаления сообщения по id без запроса на сервер
          // message_ids - для манипуляций с массивом сообщений (например смена статуса) без запроса
          // is_read - для пометки "прочитано"
          if (data.publish_data.user_id === currentUserId) {
            context.commit('SET_DIALOG_MESSAGES_WRAP_AUTO_SCROLL', true)
          }
          if (data.publish_data.message_ids && data.publish_data.is_read) {
            const updateData = {
              roomId: data.publish_data.room_id,
              messageIds: data.publish_data.message_ids
            }
            context.commit('SET_DIALOG_MESSAGES_IS_READ', updateData)
            // очищаем счетчик комнаты
            context.commit('RESET_DIALOG_ROOM_COUNTER', updateData)
            context.commit('UPDATE_DIALOG_WIDGET_COUNTER')
          }
          if (data.publish_data.removed_id) {
            context.commit('REMOVE_DIALOG_MESSAGE', data.publish_data.removed_id)
            context.dispatch('updateDialogRoomLastMessage', data.publish_data)
          }
          // обновляем список сообщений пока только для новых
          if (data.publish_data.is_new) {
            context.dispatch('getDialogRoomMessageList', data.publish_data.room_id)
            context.dispatch('updateDialogRoomLastMessage', data.publish_data)
          }
          if (data.publish_data.is_updated) {
            const messageData = {
              messageId: data.publish_data.is_updated,
              roomId: data.publish_data.room_id
            }
            context.commit('SET_DIALOG_MESSAGES_WRAP_AUTO_SCROLL', false)
            context.dispatch('updateDialogRoomMessage', messageData)
            context.dispatch('updateDialogRoomLastMessage', data.publish_data)
          }
          break
        case 'user-prints-message':
          // TODO: продумать логику показа печатающего, чтобы небыло 2-х одновременно и тамауты не перебивались
          /* context.commit('TOGGLE_DIALOG_WHO_PRINTS', data.publish_data.user_id) */
          break
        case 'update-room':
          // is_pinned - id сообщения, которое закрепляют, если открепляют то null
          if (data.publish_data.is_pinned || data.publish_data.is_pinned === null) {
            const pinData = {
              roomId: data.publish_data.room_id,
              messageId: data.publish_data.is_pinned
            }
            context.dispatch('updateDialogRoomPinnedMessage', pinData)
          } else {
            context.dispatch('setActiveDialog', data.publish_data.room_id)
          }
          break
        default: break
      }
    }

    // вынесено за условие чтобы срабатывало независимо от активного диалога
    switch (data.value) {
      case 'update-messages':
        if (data.publish_data.is_new) {
          // запрашиваем заного список комнат чтобы сработала сортировка и комната с новым сообщением поднялась вверх
          context.dispatch('getDialogRoomList', { needSubscribe: false, updateCurrent: false }).then(() => {
            context.commit('UPDATE_DIALOG_WIDGET_COUNTER')
          })
        }
        break
      default: break
    }

    // слушаем системный канал
    switch (data.value) {
      case 'system_update-room-list':
        // если юзер есть в списке участников новой комнаты чата, тогда обновляем для него список комнат
        // is_removed - означает что комната была удалена
        // is_updated - означает что комната была отредактирована (изменился состав юзеров, название, цвет)
        if (data.publish_data.room_users.indexOf(currentUserId) + 1 && data.publish_data.is_removed) {
          context.commit('REMOVE_ACTIVE_DIALOG_ROOM')
          // false передаём для того чтобы обозначить что переподписываться на каналы в этом случае не нужно
          // так как комната удаляется
          context.dispatch('getDialogRoomList', { needSubscribe: false, updateCurrent: false })
        } else if (data.publish_data.room_users.indexOf(currentUserId) + 1 && data.publish_data.is_updated) {
          context.dispatch('getDialogRoomList', { needSubscribe: true, updateCurrent: data.publish_data.room_id })
        } else if (data.publish_data.room_users.indexOf(currentUserId) + 1) {
          context.dispatch('getDialogRoomList', { needSubscribe: true, updateCurrent: false })
        }
        break
      default: break
    }

    // установка уведомлений
    if (data.type && data.model) {
      let newNotification

      if (data.model.event_item) newNotification = data.model.event_item
      else {
        newNotification = {
          ...data.model,
          ...data.model.approve,
          ...data.relation_model,
          itemable_type: data.model_type,
          type: data.type
        }
      }

      newNotification.created_at = data.created_at
      context.commit('GET_WIDGET_NEW_NOTIFICATIONS', [newNotification, ...context.state.notificationWidget.notifications])
    }
  })
}
